'use client'

import React from 'react'
import styles from './enterpriseCompare.module.scss'

const Index = ({ data }) => {
  const { title, ComparisonHead, ComparisonBody } = data?.data

  return (
    <div className={styles.main}>
      <h2 className={styles.mainTitle}>{title}</h2>
      <h3 className={styles.tableHead}>
        {ComparisonHead?.map(th => (
          <div key={th?.id} className={styles.tableHeadText}>{th?.text}</div>
        ))}
      </h3>
      <div>
        {ComparisonBody?.map(td => {
          const { id, ...filtered } = td
          return (
          <div key={filtered?.metric} className={styles.tableBody}>{
            Object.values(filtered)?.map((val: string) => (
              <div key={val} className={styles.tableValue}>{val}</div>
            ))
          }</div>
        )
})}
      </div>
    </div>
  )
}

export default Index
